<section class="page-shell">
  <header class="page-header">
    <h4>Relations inter-consultants ({{ page()?.totalCount }})</h4>

    <div class="page-header-actions">
      <oui-button
        iconSuffix="download"
        (click)="exportCsv()"
        [disabled]="exporting() || loading()">
        Export CSV
      </oui-button>
      <oui-button
        color="secondary"
        type="outlined"
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Recherche impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }
  <!-- @if (page(); as vm) {
    <dbw-summary-grid [items]="summaryItems()"></dbw-summary-grid>
  } -->

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <section class="content-grid">
    <article class="panel search-panel dbw-card dbw-card--xl">
      <h5>Filtres</h5>
      <div class="filters">
        <div class="filters-row">
          <oui-textfield
            label="ConsultantId"
            type="number"
            [value]="consultantIdFilter()"
            (valueChange)="onConsultantIdFilterChange($event ? $event.toString() : '')">
          </oui-textfield>
          <oui-textfield
            label="Code consultant"
            [value]="consultantCodeFilter()"
            (valueChange)="onConsultantCodeFilterChange($event ? $event.toString() : '')">
          </oui-textfield>
          <oui-textfield
            label="Nom consultant"
            [value]="consultantNameFilter()"
            (valueChange)="onConsultantNameFilterChange($event ? $event.toString() : '')">
          </oui-textfield>
        </div>
      </div>
    </article>

    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h4>Investisseurs détectés</h4>
          <p>{{ page()?.totalCount ?? 0 }} investisseur(s) correspondant au filtre.</p>
        </div>
      </div>

      @if (!loading() && !error() && (page()?.items?.length ?? 0) === 0) {
        <div class="empty-state">Aucun investisseur ne correspond au filtre courant.</div>
      }

      @if (loading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement des relations inter-consultants en cours.</p>
        </dbw-state-card>
      }

      @if (!loading() && (page()?.items?.length ?? 0) > 0) {
        <div class="table-shell">
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="page()?.items ?? []">
              <ng-container matColumnDef="investor">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseur
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-investor-card
                    [id]="row.investorId"
                    [code]="row.investorCode || '-'"
                    [name]="row.displayName"
                    [statusCode]="row.statusCode"></dbw-investor-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Statut
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-investor-status-tag [statusCode]="row.statusCode"></dbw-investor-status-tag>
                </td>
              </ng-container>

              <ng-container matColumnDef="consultant">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultant source
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-card
                    [id]="row.consultantId"
                    [code]="row.consultantCode || '-'"
                    [name]="row.consultantName || '-'"
                    [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="relationKinds">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Relations
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="content-short">
                    <div>{{ formatRelationKinds(row.relationKinds) || '-' }}</div>
                    <div>{{ row.relationCount }} relation(s) vers {{ row.relatedInvestorCount }} investisseur(s)</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="relatedInvestors">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseurs liés
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="multiline-values">
                    @for (relatedInvestor of row.relatedInvestors; track relatedInvestor.investorId) {
                      <div>
                        <strong>
                          <a [routerLink]="appRoutePaths.atlas.investor(relatedInvestor.investorId)">
                            {{ relatedInvestor.displayName }}
                          </a>
                        </strong>
                        <div>
                          #{{ relatedInvestor.investorId }} •
                          {{ formatConsultantLabel(relatedInvestor.consultantCode, relatedInvestor.consultantName) }}
                        </div>
                        <div>
                          {{ formatRelationKinds(relatedInvestor.relationKinds) || '-' }}
                        </div>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </oui-table>

          <mat-paginator
            [length]="page()?.totalCount ?? 0"
            [pageIndex]="page()?.pageIndex ?? pageIndex()"
            [pageSize]="page()?.pageSize ?? pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      }
    </article>
  </section>
</section>
